import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    count: 0,
    unreadByCreator: {},
    items: [],
    total: 0,
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        increment: (state, action) => {
            const { creatorId, amount = 1 } = action.payload || {};
            state.count += amount;

            if (creatorId) {
                state.unreadByCreator[creatorId] =
                    (state.unreadByCreator[creatorId] || 0) + amount;
            }

            // syncAppBadge(state.count);
        },

        read: (state, action) => {
            const { creatorId, notificationId } = action.payload || {};

            if (creatorId && state.unreadByCreator[creatorId]) {
                const readCount = state.unreadByCreator[creatorId];
                state.count = Math.max(0, state.count - readCount);
                state.unreadByCreator[creatorId] = 0;
            }

            // if a specific notification id is passed, mark it read in the list too
            if (notificationId != null) {
                const item = state.items.find((n) => n.id === notificationId);
                if (item && !item.read_at) {
                    item.read_at = new Date().toISOString();
                }
            }

            // syncAppBadge(state.count);
        },

        readAll: (state) => {
            state.count = 0;
            state.unreadByCreator = {};
            state.items = state.items.map((n) => ({
                ...n,
                read_at: n.read_at || new Date().toISOString(),
            }));
            // syncAppBadge(0);
        },

        setCount: (state, action) => {
            console.log('action.payload', action.payload)
            state.count = action.payload || 0;
            // syncAppBadge(state.count);
        },

        setNotifications: (state, action) => {
            const { data = [], total = 0, unread_count = 0 } = action.payload || {};
            state.items = data;
            state.total = total;
            // state.count = unread_count;

            // rebuild per-creator unread map from the list
            // state.unreadByCreator = data.reduce((acc, n) => {
            //     const creatorId = n.data?.creator_id;
            //     if (creatorId && !n.read_at) {
            //         acc[creatorId] = (acc[creatorId] || 0) + 1;
            //     }
            //     return acc;
            // }, {});

            // syncAppBadge(state.count);
        },

        addNotification: (state, action) => {
            const notification = action.payload;
            state.items.unshift(notification);
            state.total += 1;
            // state.count += 1;

            // const creatorId = notification.data?.creator_id;
            // if (creatorId) {
            //     state.unreadByCreator[creatorId] = (state.unreadByCreator[creatorId] || 0) + 1;
            // }

            // syncAppBadge(state.count);
        },
    },
});

function syncAppBadge(count) {
    if ('setAppBadge' in window.navigator) {
        if (count > 0) {
            window.navigator.setAppBadge(count).catch(() => { });
        } else {
            window.navigator.clearAppBadge().catch(() => { });
        }
    }
}

export const {
    increment,
    read,
    readAll,
    setCount,
    setNotifications,
    addNotification,
} = notificationSlice.actions;

export const selectUnreadCount = (state) => state.notification?.count || 0;
export const selectNotifications = (state) => state.notification?.items || [];
export const selectNotificationTotal = (state) => state.notification?.total || 0;
export const selectUnreadByCreator = (creatorId) => (state) =>
    state.notification.unreadByCreator[creatorId] || 0;

export default notificationSlice.reducer;